import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { push } from 'connected-react-router';
import { FullLoading } from '../../components/Loading';

const User = React.lazy(() => import('./user'));
const Assets = React.lazy(() => import('./assets'));
const Deduction = React.lazy(() => import('./deduction'));
const Result = React.lazy(() => import('./result'));
const EditEnd = React.lazy(() => import('./editend'));
const Edit = React.lazy(() => import('./edit'));
const End = React.lazy(() => import('./end'));

class Index extends React.Component {
  componentDidMount() {
    const { customer, dispatch } = this.props;
    if (!customer.isAuth) {
      dispatch(push('/'));
      return null;
    }
  }
  render() {
    const { match } = this.props;
    return (
      <Container>
        <Row className="justify-content-center">
          <Col xl={8} lg={10} md={12}>
            <React.Suspense fallback={<FullLoading />}>
              <Switch>
                <Route exact path={`${match.url}`}>
                  <Redirect to={`${match.url}/user`} />
                </Route>
                <Route path={`${match.url}/user`} component={User} />
                <Route path={`${match.url}/assets`} component={Assets} />
                <Route path={`${match.url}/deduction`} component={Deduction} />
                <Route path={`${match.url}/result`} component={Result} />
                <Route path={`${match.url}/edit`} component={Edit} />
                <Route path={`${match.url}/editend`} component={EditEnd} />
                <Route exact path={`${match.url}/end`} component={End} />
              </Switch>
            </React.Suspense>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default connect(s => s)(Index);
